export async function getBlobBaseFee(client){const baseFee=await client.request({method:"eth_blobBaseFee"});return BigInt(baseFee)}